$(document).ready(function () {
	Anchortags();
	// function to featch all the anchor tags
	//RedirectToExternalDomain(url, target, anchorParent);
});

function RedirectToExternalDomain(url, target, anchorParent) {
	$("#submitbutton").on("click", function (e) {
		var submit_element = $(this);
		submit_element.attr('href', url);
		submit_element.attr('target', target);
		anchorParent.find("ul.nav-main-mobile-panel.nav-main-mobile-panel-menu:first").each(function () {
			$(this).attr("class", "nav-main-mobile-panel nav-main-mobile-panel-menu nav-main-mobile-panel-active");
		});
		// Hide the model pop up after links opened in New tab
		// trigger the cancel button event
		if (submit_element.attr("target") == "_blank") {
			$("#cancelbutton .btn-cancel").trigger("click");
		}
	});
	$("#cancelbutton").on("click", function (e) {
		anchorParent.find("ul.nav-main-mobile-panel.nav-main-mobile-panel-menu:first").each(function () {
			$(this).attr("class", "nav-main-mobile-panel nav-main-mobile-panel-menu nav-main-mobile-panel-active");
		});
	});
}
function Anchortags() {
	if ($('#MicorsiteModalPopup').length) {
		$("a").each(function (index) {
			var anchor_element = $(this);
			var currentLink = anchor_element.attr("href");
			var currentLinkwithoutQuery = currentLink != undefined ? currentLink.split("?")[0] : currentLink;
			var parentElement = anchor_element.parents('nav[id^="nav-main-mobile"]').eq(0);

			var currentLinkTarget = anchor_element.attr("target");
			if (currentLinkTarget == undefined)
				currentLinkTarget = "_self";
			if (currentLink != undefined && currentLink != '#' && currentLink != '/' && !currentLink.includes("#mm-") && !currentLink.includes("javascript:void(0);") && !currentLink.includes("barCodeBox") && !currentLink.includes("/dfsmedia/") && !currentLink.includes("#emailshare-sample") && !currentLink.includes("#acc-pnl") && (currentLink.includes("https") || currentLink.includes("http")) && (currentLinkwithoutQuery.indexOf(location.host) === -1)) {
				var libraryDownloadLength = anchor_element.parents('td[class^="resource-list-action"]').length;

				if (libraryDownloadLength !== 0) {
					anchor_element.removeAttr('onclick');
					anchor_element.on("click", function () {

						var PDFTitle = event.srcElement.getAttribute('data-GTMDownloadtitle');
						var fileExtension = event.srcElement.getAttribute('data-GTMFileExtension');
						var businessUnit = event.srcElement.getAttribute('data-GTMBusinessLine');
						if ($(event.srcElement).closest('a').attr('href')) {
							var assetId = GetLibraryAssetIdForDownloadEvent($(event.srcElement).closest('a').attr('href'));
						}
						if (PDFTitle) {
							GTMDownloadEvent(PDFTitle, fileExtension, businessUnit, assetId);
						}

						RedirectToExternalDomain(currentLink, currentLinkTarget, parentElement);
					});
				}
				else {
					anchor_element.on("click", function () { RedirectToExternalDomain(currentLink, currentLinkTarget, parentElement); });
				}

				anchor_element.attr('href', '#MicorsiteModalPopup');
				anchor_element.attr("data-bs-toggle", "modal");
				anchor_element.attr("data-bs-target", "#MicorsiteModalPopup");
			}
		});
	}

}

window.addEventListener("load", function () {
	// Function to fire after few secs
	setTimeout(function () {
		Anchortags();
		// function to featch all the anchor tags
		//RedirectToExternalDomain(url, target, anchorParent);
	}, 1000);

});
